import React from 'react';
import { CollapseIcon } from '../../icons/navigation';

interface SidebarCollapseButtonProps {
  onClick: () => void;
  side: 'left' | 'right';
  title?: string;
}

const SidebarCollapseButton: React.FC<SidebarCollapseButtonProps> = ({
  onClick,
  side,
  title,
}) => {
  return (
    <button
      onClick={onClick}
      className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      title={title || `Collapse ${side} sidebar`}
    >
      <CollapseIcon
        size={20}
        className={`text-gray-600 dark:text-gray-300 ${side === 'right' ? 'scale-x-[-1]' : ''}`}
      />
    </button>
  );
};

export default SidebarCollapseButton;
